import React from 'react'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import PrintText from '../../lib/PrintText'

export default function UstalenieSposobuSporzadzenia(props) {
  return (
    <ExpandablePanel title="ZASADY USTALENIA SPOSOBU SPORZĄDZENIA SPRAWOZDANIA FINANSOWEGO">
      <form autoComplete="off" className="subsection">
        {props.czyPodsumowanie ? (
          <PrintText
            text={props.data.UstalenieSposobuSporzadzenia}
          />
        ) : (
          <TextField
            error={controlHasError(
              props.errors,
              'UstalenieSposobuSporzadzenia',
              props.data.UstalenieSposobuSporzadzenia,
            )}
            name="UstalenieSposobuSporzadzenia"
            label="Opis"
            multiline
            variant="outlined"
            title={props.data.UstalenieSposobuSporzadzenia}
            defaultValue={props.data.UstalenieSposobuSporzadzenia}
            onBlur={(e) =>
              props.onSetSectionData(
                'UstalenieSposobuSporzadzenia',
                e.target.value,
              )
            }
          />
        )}
      </form>
    </ExpandablePanel>
  )
}
